import { Link } from "react-router-dom";
import PageChrome from "@/layouts/PageChrome.jsx";

export default function NotFound() {
    return (
        <main className="mx-auto flex w-full max-w-lg flex-col items-center gap-4 p-6 py-24 text-center">
            <PageChrome breadcrumb={["Not found"]} title="Not found" />

            <span className="grid size-12 place-items-center rounded-full bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500">
                <svg
                    className="size-6"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                >
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 8v4.5M12 16h.01" />
                </svg>
            </span>

            <h1 className="text-[20px] font-semibold tracking-tight">Page not found</h1>
            <p className="text-[13.5px] leading-relaxed text-slate-500 dark:text-slate-400">
                That address does not match any page. If you followed a bookmark from the previous
                dashboard, the paths are unchanged — so it is more likely a typo than a moved page.
            </p>

            <Link to="/dashboard" className="btn btn-primary mt-2">
                Go to dashboard
            </Link>
        </main>
    );
}
